import createIcon from '../../createIcon';

/**
 * @component @name PhotoCameraFront
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggMTAuNDhMMjIgNi41VjE3LjVMMTggMTMuNTJWMThDMTggMTkuMSAxNy4xIDIwIDE2IDIwSDRDMi45IDIwIDIgMTkuMSAyIDE4VjZDMiA0LjkgMi45IDQgNCA0SDE2QzE3LjEgNCAxOCA0LjkgMTggNlYxMC40OFpNMTYgNkg0VjE4SDE2VjZaTTEwIDEyQzguOSAxMiA4IDExLjEgOCAxMEM4IDguOSA4LjkgOCAxMCA4QzExLjEgOCAxMiA4LjkgMTIgMTBDMTIgMTEuMSAxMS4xIDEyIDEwIDEyWk0xMCAxM0MxMS4zNCAxMyAxNCAxMy42NyAxNCAxNVYxNkg2VjE1QzYgMTMuNjcgOC42NiAxMyAxMCAxM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PhotoCameraFront = createIcon('PhotoCameraFront', [
  [
    'path',
    {
      d: 'M18 10.48L22 6.5V17.5L18 13.52V18C18 19.1 17.1 20 16 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4H16C17.1 4 18 4.9 18 6V10.48ZM16 6H4V18H16V6ZM10 12C8.9 12 8 11.1 8 10C8 8.9 8.9 8 10 8C11.1 8 12 8.9 12 10C12 11.1 11.1 12 10 12ZM10 13C11.34 13 14 13.67 14 15V16H6V15C6 13.67 8.66 13 10 13Z',
      key: '1f169j',
    },
  ],
]);

export default PhotoCameraFront;
